import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const THead = ({ thCells, isTableLayout, shouldRenderRow, style, className, staticRows }) =>
  isTableLayout ? (
    <thead className={className} style={style}>
      {staticRows}
      {shouldRenderRow && <tr>{thCells}</tr>}
    </thead>
  ) : (
    <div className={cx('d-thead', className)} style={style}>
      {staticRows && (
        <div className="d-table" style={{ width: '100%' }}>
          {staticRows}
        </div>
      )}
      <div className="d-table" style={{ width: '100%' }}>
        {shouldRenderRow && <div className="d-table-row">{thCells}</div>}
      </div>
    </div>
  );

THead.propTypes = {
  thCells: T.array.isRequired,
  isTableLayout: T.bool.isRequired,
  shouldRenderRow: T.bool,
  staticRows: T.node,
  className: T.string,
  style: T.object,
};

THead.defaultProps = {
  shouldRenderRow: true,
  // className: 'thead-gray',
};

export default THead;
